import { createSelector } from '@ngrx/store';
import { onlineOrderState } from '../root';

export const getQuoteDelivery = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.quoteDelivery);
